import api from "../api";
import AppConstants from "../constants/AppConstants";
import handleError from "../helpers/requestErrorHandler";

const loadingStart = () =>({
    type: AppConstants.INFO_DOCS_LOADING_START
})

const setDocs = response =>({
    type: AppConstants.INFO_DOCS_SET,
    payload: response
})

const loadingFail = () =>({
    type: AppConstants.INFO_DOCS_LOADING_FAIL
})

export const searchDocs = params => dispatch => {
    dispatch(loadingStart());
    api.searchInfoDocs(params)
        .then(data => {
            dispatch(setDocs(data.response || {}));
        })
        .catch(error => {
            handleError(error, () => {
                dispatch(loadingFail());
            })
        })
}
